import { render } from "./RenderButtonsBar.vue?vue&type=template&id=075040f1"
import script from "./RenderButtonsBar.vue?vue&type=script&lang=js"
export * from "./RenderButtonsBar.vue?vue&type=script&lang=js"

import exportComponent from "/www/wwwroot/plus.centrodeglaucoma.com/darmin-plus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__